export default __webpack_public_path__ + "static/media/award3.55f72e46.svg";